import { IconProps } from "../../utils/global-types/global-types";

const DeleteTrashOpenIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    className={className ? className : "w-6 h-6"}
    {...rest}
  >
    <g fill="#E13F41" clipPath="url(#clip0_7510_22455)">
      <path d="M17.507 6.421h-9.25l4.142-4.142a.586.586 0 0 0 0-.829L11.349.4a1.367 1.367 0 0 0-1.933 0l-1.08 1.08-.552-.553c-.61-.609-1.6-.609-2.21 0L3.419 3.082c-.609.61-.609 1.6 0 2.21l.553.552-1.08 1.08a1.367 1.367 0 0 0 0 1.933l1.05 1.05c.23.228.6.229.829 0L6.256 8.42v9.04A2.54 2.54 0 0 0 8.796 20h6.171a2.54 2.54 0 0 0 2.54-2.54zM4.8 5.015l-.553-.552a.39.39 0 0 1 0-.553l2.155-2.154a.39.39 0 0 1 .552 0l.553.552zM9.86 16.72a.586.586 0 0 1-1.173 0V9.703a.586.586 0 1 1 1.172 0zm2.606 0a.586.586 0 1 1-1.172 0V9.703a.586.586 0 1 1 1.172 0zm2.607 0a.586.586 0 0 1-1.172 0V9.703a.586.586 0 1 1 1.172 0z"></path>
      <path d="M12.534 4.436a.98.98 0 0 0-.65.814h5.623v-.974a.977.977 0 0 0-1.29-.925l-3.67 1.081z"></path>
    </g>
    <defs>
      <clipPath id="clip0_7510_22455">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default DeleteTrashOpenIcon;
